export const PROJECTS = ['hatfa', 'kitaba'] as const;

export type Project = (typeof PROJECTS)[number];

export type ProjectCapabilities = {
  languages: boolean;
  lessons: boolean;
  circularCover: boolean;
  epub: boolean;
  authorBirthday: boolean;
};

export type ProjectConfig = {
  label: string;
  apiUrl: string;
  capabilities: ProjectCapabilities;
};

const viteEnv: Partial<ImportMetaEnv> = import.meta.env || {};

export const projectConfigs: Record<Project, ProjectConfig> = {
  hatfa: {
    label: 'Hatfa',
    apiUrl: viteEnv.VITE_HATFA_API_URL || viteEnv.VITE_API_URL || '',
    capabilities: {
      languages: true,
      lessons: true,
      circularCover: true,
      epub: false,
      authorBirthday: false,
    },
  },
  kitaba: {
    label: 'Kitaba',
    apiUrl: viteEnv.VITE_KITABA_API_URL || '',
    capabilities: {
      languages: false,
      lessons: false,
      circularCover: false,
      epub: true,
      authorBirthday: true,
    },
  },
};

export function isProject(value: string | undefined): value is Project {
  return PROJECTS.includes(value as Project);
}
